import React, { useState, useEffect, useRef } from 'react'
import { FaTimes } from 'react-icons/fa'

const Accion = ({ accion, paqueteId, seccionId, quitarAccion, costoUbicacion, areaIntervenir, actualizarCosto }) => {
    const [costoTotal, setCostoTotal] = useState(accion.montoTotal || 0)
    const [isManual, setIsManual] = useState(false)
    const cargaInicial = useRef(false) 

    useEffect(() => {
        if (!cargaInicial.current) {
            setCostoTotal(accion.montoTotal)
            cargaInicial.current = true
            return
        }

        if (!isManual) {
            const costoBase = parseFloat(accion.costo_base) || 0
            const costoPorUbicacion = parseFloat(costoUbicacion) || 0
            const metraje = parseFloat(areaIntervenir) || 0
            let costoCalculado = costoBase

            if (accion.sujeto_metraje) {
                costoCalculado *= metraje
            }
            if (accion.sujeto_ubicacion) {
                costoCalculado += costoPorUbicacion
            }

            if (costoCalculado !== costoTotal) {
                setCostoTotal(costoCalculado)
                actualizarCosto(paqueteId, seccionId, accion.id, costoCalculado)
            }
        }
    }, [accion, areaIntervenir, costoUbicacion, isManual])

    const handleCostoChange = (e) => {
        const nuevoCosto = parseFloat(e.target.value) || 0
        setCostoTotal(nuevoCosto)
        setIsManual(true)
        actualizarCosto(paqueteId, seccionId, accion.id, nuevoCosto)
    }

    useEffect(() => {
        if (isManual) {
            setIsManual(false)
        }
    }, [areaIntervenir, costoUbicacion])

    return (
        <div className="bg-white border border-gray-200 p-1 rounded-sm flex items-center gap-2 text-sm">
            <button
                onClick={(e) => quitarAccion(e, paqueteId, seccionId, accion.id)}
                className="p-1 bg-transparent hover:bg-red-200 rounded-full text-red-600 hover:text-red-800 focus:outline-none"
                aria-label="Eliminar acción"
            >
                <FaTimes size={12} />
            </button>

            <input
                type="number"
                value={costoTotal} 
                onChange={handleCostoChange}
                placeholder="Costo total"
                className="border border-gray-300 rounded-sm p-1 text-sm w-24 focus:ring-1 focus:ring-blue-500 focus:outline-none"
            />
            <h4 className="font-semibold truncate">{accion.accion}</h4>
        </div>
    )
}

export default Accion
